module.exports = __webpack_public_path__ + "media/images/icons/ic-send-04964cf9f98f09b40317c8dd6c3e275d.svg";